// extracted by mini-css-extract-plugin
export default {"wrapperReferralCopyContent":"ReferralCopyContent_wrapperReferralCopyContent__EgM1Q","marginB":"ReferralCopyContent_marginB__aJ8pS","bg":"ReferralCopyContent_bg__QjKjs"};